<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3">
<p class="subtitle">YOUR TOWNS &amp; CITIES IN WORLD WAR TWO</p>
<div class="img_container1"><img alt="image" src="images/line.jpg"/></div>
<h1 class="title">EDINBURGH</h1>
<p class="author1">AT WAR <span class="gray">1939-45</span></p>
<p class="author">CRAIG ARMSTRONG</p>
<div class="pub_1"><img alt="image" src="images/pub.jpg"/></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?29cdbf97